import key from "../config/config";
import * as api from "../routes/userroutefront";
import axios from "../config/axios";

export const getDashboardBanners = async () => {
  try {
    const respData = await axios({
      url: key.API_URL + api.getDashboardBanners,
      method: "get",
    });

    return {
      status: respData?.data?.status,
      message: respData?.data?.message,
      useStaticFallback: respData?.data?.useStaticFallback,
      result: respData?.data?.result || [],
    };
  } catch (err) {
    return {
      status: false,
      message: err?.response?.data?.message,
      useStaticFallback: true,
      result: [],
    };
  }
};
